// Traduções — Inglês. Chave = texto usado no t() (ver src/i18n.js).
const en = {
  'Welcome back': 'Welcome back',
  'Yes': 'Yes',
  'No': 'No',
  'Dashboard': 'Dashboard',
  "We've missed you": "We've missed you",
  'Users': 'Users',
  'User': 'User',
  'user': 'user',
  'judge': 'judge',
  'producer': 'producer',
  'Edit User': 'Edit User',
  'Edit Producer': 'Edit Producer',
  'Edit Judge': 'Edit Judge',
  'Add User': 'Add User',
  'Add Producer': 'Add Producer',
  'Add Judge': 'Add Judge',
  'Name': 'Name',
  'Full Name': 'Full Name',
  'Lastname': 'Lastname',
  'E-mail': 'E-mail',
  'Language': 'Language',
  'Languages': 'Languages',
  'Role': 'Role',
  'Actions': 'Actions',
  'New User': 'New User',
  'Save': 'Save',
  'Save Changes': 'Save Changes',
  'Producer': 'Producer',
  'Judge': 'Judge',
  'Produtor': 'Producer',
  'Jurado': 'Judge',
  'Admin': 'Admin',
  'Administrador': 'Admin',
  'Password': 'Password',
  'Confirm Password': 'Confirm Password',
  'Portuguese': 'Portuguese',
  'English': 'English',
  'Spanish': 'Spanish',
  'Italian': 'Italian',
  'French': 'French',
  'Close': 'Close',
  'Occured an Error': 'An error occurred',
  'Done': 'Done',
  'User registred successfully': 'User registred successfully',
  'Required field': 'Required field',
  'User updated successfully': 'User updated successfully',
  'Product registered successfully': 'Product registered successfully',
  'Registration updated successfully': 'Registration updated successfully',
  "Farm's Name": "Farm's Name",
  "Farm's Legal Representative": "Farm's Legal Representative",
  'Country': 'Country',
  'State': 'State',
  'Status': 'Status',
  'Active': 'Active',
  'Inactive': 'Inactive',
  'Producers': 'Producers',
  'Judges': 'Judges',
  'Website': 'Website',
  'Phone Number': 'Phone Number',
  'Cellphone Number': 'Cellphone Number',
  'Document Number': 'Document Number',
  'RG': 'RG',
  'CPF': 'CPF',
  'CNPJ': 'CNPJ',
  'Passport': 'Passport',
  'ID Document Type': 'ID Document Type',
  'City': 'City',
  'Zip-Code': 'Zip-Code',
  'Producer updated successfully': 'Producer updated successfully',
  'Judge updated successfully': 'Judge updated successfully',
  'Curator updated successfully': 'Curator updated successfully',
  'Curator registered successfully': 'Curator registered successfully',
  'Producer registered successfully': 'Producer registered successfully',
  'Judge registered successfully': 'Judge registered successfully',
  'A confirmation e-mail was sent to the registered e-mail address.':
    'A confirmation e-mail was sent to the registered e-mail address.',
  'Producer Registration': 'Producer Registration',
  'Judge Registration': 'Judge Registration',
  'New Producer': 'New Producer',
  'New Judge': 'New Judge',
  'Subscribe another product': 'Subscribe another product',
  'Register new product': 'Register new product',
  'Edit Registration': 'Edit Registration',
  'Registration Detail': 'Registration Detail',
  "Product's Name": "Product's Name",
  'Certificate Type': 'Certificate Type',
  'Municipal Certificate': 'Municipal Certificate',
  'State Certificate': 'State Certificate',
  'Federal Certificate': 'Federal Certificate',
  'Municipal': 'Municipal Certificate',
  'Estadual': 'State Certificate',
  'Federal': 'Federal Certificate',
  'Selo Arte': 'Art Stamp',
  'Art Stamp': 'Art Stamp',
  "Products's Characteristics": "Products's Characteristics",
  'Group': 'Group',
  'Origin': 'Origin',
  'Creation Date': 'Creation Date',
  'Update Date': 'Update Date',
  'Milk Type': 'Milk Type',
  'Raw': 'Raw',
  'Pasteurized': 'Pasteurized',
  'Manufacturing Date': 'Manufacturing Date',
  'Dough Treatment': 'Dough Treatment',
  'Rind Type': 'Rind Type',
  'Registrations': 'Registrations',
  'New Product Registration': 'New Product Registration',
  'Certificate': 'Certificate',
  'Code': 'Code',
  'Paid': 'Paid',
  'Orders': 'Orders',
  'Orders History': 'Orders History',
  'Reviews': 'Reviews',
  'Administrative': 'Administrative',
  'Brazil': 'Brazil',
  'Italy': 'Italy',
  'United States': 'United States',
  'France': 'France',
  'Germany': 'Germany',
  'Spain': 'Spain',
  'Approved': 'Approved',
  'Reprovado': 'Failed',
  'Pending': 'Pending',
  'Occupation': 'Occupation',
  'of': 'of',
  'more than': 'more than',
  'Proficiency Languages': 'Proficiency Languages',
  'Male': 'Male',
  'Female': 'Female',
  'Other': 'Other',
  'Nationality': 'Nationality',
  'Gender': 'Gender',
  'Educational Background': 'Educational Background',
  'Professional Activity': 'Professional Activity',
  'Company': 'Company',
  'Add File': 'Add File',
  'Delete': 'Delete',
  'Are you sure that you want to delete': 'Are you sure that you want to delete',
  'Item deleted successfully!': 'Item deleted successfully!',
  'Cart': 'Cart',
  'Description': 'Description',
  'Amount': 'Amount',
  'Go to payment': 'Go to payment',
  'Items': 'Items',
  'Remove': 'Remove',
  'Order Summary': 'Order Summary',
  'Contest Parameters': 'Contest Parameters',
  'Payment Expiring Date': 'Payment Expiring Date',
  'Logout': 'Logout',
  'ID da Propriedade': 'Property ID',
  'Passaporte': 'Passport',
  'Approve': 'Approve',
  'Disapprove': 'Disapprove',
  'Invoices': 'Invoices',
  'Order number': 'Order number',
  'Order total': 'Order total',
  'Cash Credit Card': 'Cash Credit Card',
  'Credit card in': 'Credit card in',
  'installments': 'installments',
  'Credit Card': 'Credit Card',
  'Payment method': 'Payment method',
  'Payment Method': 'Payment Method',
  'YOUR NAME': 'YOUR NAME',
  'Card Number': 'Card Number',
  'Card Name': 'Card Name',
  'Valid Thru': 'Valid Thru',
  'Installments': 'Installments',
  'Finish Order': 'Finish Order',
  'Finish Payment': 'Finish Payment',
  'Válido até às': 'Valid thru',
  'Copy Pix Code': 'Copy Pix Code',
  'Payment Info': 'Payment Info',
  'Pix à vista': 'Pix',
  'Boleto à vista': 'Boleto',
  'Order': 'Order',
  'Payment Date': 'Payment Date',
  'Vencida': 'Expired',
  'Aguardando pagamento': 'Waiting for payment',
  'Expiring Date': 'Expiring Date',
  'Expired in': 'Expired in',
  'Print': 'Print',
  'Order Completed': 'Order Completed',
  'Inscricao': 'Awards Registration',
  'Log In': 'Log In',
  'Sign up': 'Sign up',
  'Remember me': 'Remember me',
  'Change my password': 'Change my password',
  'Back to login': 'Back to login',
  'Choose your role': 'Choose your role',
  'Paying Method': 'Paying Method',
  'CartaoCredito': 'Credit Card',
  'Order Details': 'Order Details',
  'Click on the link in this e-mail to validate your registration.':
    'Click on the link in this e-mail to validate your registration.',
  'Register': 'Register',
  'Successful Registration': 'Successful Registration',
  'E-mail inválido': 'Invalid e-mail',
  'Campo obrigatório': 'Mandatory field',
  'New Password': 'New Password',
  'Password changed successfully': 'Password changed successfully',
  'Change password': 'Change password',
  'Delete file': 'Delete file',
  'days': 'days',
  'Product Information': 'Product Information',
  'Review Sheet': 'Review Sheet',
  'Review Sheets': 'Review Sheets',
  'Maturation Days': 'Maturation Days',
  "Product's Code": "Product's Code",
  'Estragado': 'Expired',
  'Péssimo': 'Terrible',
  'Ruim': 'Bad',
  'Insuficiente': 'Not enough',
  'Razoável': 'Ordinary',
  'Suficiente': 'Enough',
  'Bom': 'Good',
  'Ótimo': 'Great',
  'Excelente': 'Excellent',
  'Perfeito': 'Perfect',
  'Send Review': 'Send Review',
  'General Aspect': 'General Aspect',
  'Color': 'Color',
  'Texture': 'Texture',
  'Odor': 'Odor',
  'Scent': 'Scent',
  'Consistency': 'Consistency',
  'Flavor': 'Flavor',
  'Payment': 'Payment',
  'Title / Aspect': 'Title / Aspect',
  'Title': 'Title',
  'Aspect': 'Aspect',
  'Max Rating': 'Max Rating',
  'Weight': 'Weight',
  'Products': 'Products',
  'Product': 'Product',
  'Registration': 'Registration',
  'Cancel': 'Cancel',
  'Add': 'Add',
  'Ricotta': 'Ricotta',
  'Requeijão em Barra': 'Cottage Product',
  'Requeijão Moreno': 'Moreno Cottage Product',
  'Fresco sem tratamento': 'Unprocessed Fresh Product',
  'Com Aquecimento': 'Heated',
  'Sem Aquecimento': 'No heated',
  'Cru': 'Raw',
  'Pausterizado': 'Pausterized',
  'Vaca': 'Cow',
  'Cabra': 'Goat',
  'Ovelha': 'Sheep',
  'Búfala': 'Buffalo',
  'Outro': 'Other',
  'Event': 'Event',
  'Awards Info': 'Awards Info',
  'Contest Phase': 'Contest Phase',
  'Contest Phases': 'Contest Phases',
  'Max Grade': 'Max Grade',
  'Add question': 'Add question',
  'Contest Start Date': 'Contest Start Date',
  'Contest': 'Contest',
  'Payment Status': 'Payment Status',
  'Processando pagamento': 'Processing payment',
  'Não pago': 'Not paid',
  'Add phase': 'Add phase',
  'Contest Phase Name': 'Contest Phase Name',
  'Contest Phase Order': 'Contest Phase Order',
  'Phase Order': 'Phase Order',
  'Contest Tables': 'Contest Tables',
  'Shuffle Tables': 'Shuffle Tables',
  'Table Details': 'Table Details',
  'Registrations by Producers': 'Registrations by Producers',
  'Your Reviews': 'Your Reviews',
  'New Curator': 'New Curator',
  'Curators': 'Curators',
  'Edit Curator': 'Edit Curator',
  'Phone': 'Phone',
  'Pending Payment': 'Pending Payment',
  'Reports': 'Reports',
  'Table': 'Table',
  'Free': 'Free',
  'Move': 'Move',
  'Judge moved successfully': 'Judge moved successfully',
  'Product moved successfully': 'Product moved successfully',
  'Product reviewed successfully': 'Product reviewed successfully',
  'Return': 'Return',
  'Search': 'Search',
  'Filter': 'Filter',
  'Table QR Codes': 'Table QR Codes',
  "Print Judge's List": "Print Judge's List",
  "Print Product's List": "Print Product's List",
  'Print QR Codes': 'Print QR Codes',
  'Untie Priority': 'Untie Priority',
  'Real Time': 'Real Time',
  'Start Phase': 'Start Phase',
  'End Phase': 'End Phase',
  'Average Score': 'Average Score',
  'Total Reviews': 'Total Reviews',
  'Total Products': 'Total Products',
  'Total Judges': 'Total Judges',
  'Reset Phase': 'Reset Phase',
  'Average Score (%)': 'Average Score (%)',
  'Winner (%)': 'Winner (%)',
  'Category Winner (%)': 'Category Winner (%)',
  'Awards Results': 'Awards Results',
  'Overall Result': 'Overall Result',
  'Category Result': 'Category Result',
  'Score': 'Score',
  'Export': 'Export',
  'Qualified by Phase': 'Qualified by Phase',
  'General': 'General',
  'Second Phase': 'Second Phase',
  'Refresh': 'Refresh',
  'Selected': 'Selected',
  'Not selected': 'Not selected',
  'Deselect': 'Deselect',
  'Quantitative Assessment Form': 'Quantitative Assessment Form',
  'Selecionados': 'Selected',
  'Select Judge': 'Select Judge',
  'Export Grades': 'Export Grades',
  'Reset Event': 'Reset Event',
  'Reopen Phase': 'Reopen Phase',
  'Select a Category': 'Select a Category',
  'Please wait, exporting data...': 'Please wait, exporting data...',
  'Counting votes': 'Counting votes',
  'Heating': 'Heating',
  'Heated': 'Heated',
  'No heated': 'No heated',
  'Comment': 'Comment',
  'Table Leader': 'Table Leader',
  'Set Table Leader': 'Set Table Leader',
  'Table Leader Setup': 'Table Leader Setup',
  'Move Judge': 'Move Judge',
  'Details': 'Details',
  'Warning': 'Warning',
  'Change Table Leader': 'Change Table Leader',
  'Scan QR Code': 'Scan QR Code',
  'Loading': 'Loading',
  'Product Status': 'Product Status',
  'Shipped': 'Shipped',
  'Edit': 'Edit',
  'Unknown': 'Unknown',
  'Able': 'Able',
  'Unable': 'Unable',
  'Print Certificate': 'Print Certificate',
  'Print Seal': 'Print Seal',
  'Download Certificate': 'Download Certificate',
  'Contest Started': 'Contest Started',
  'Table Number': 'Table Number',
  'Current Contest Phase': 'Current Contest Phase',
  "Table's Leader Veredic": "Table's Leader Veredic",
  'Grade': 'Grade',
  'Print Registration Form': 'Print Registration Form',
  'Page Not Found': 'Page Not Found',
  'Print Review Report': 'Print Review Report',
  'Reviews by Attributes': 'Reviews by Attributes',
  'Move Product': 'Move Product',
  'Profession': 'Profession',
  'Registered Products': 'Registered Products',
  'Registered products management': 'Registered products management',
  'New Registration': 'New Registration',
  'Active Contest': 'Active Contest',
  'Edition': 'Edition',
  'Registration Fee:': 'Registration Fee:',
  'Payment enabled': 'Payment enabled',
  'No active contest at this time.': 'No active contest at this time.',
  'My Registration': 'My Registration',
  'Open': 'Open',
  'Registration date:': 'Registration date:',
  'Registration Date': 'Registration Date',
  'Total value:': 'Total value:',
  "You haven't started your registration yet.": "You haven't started your registration yet.",
  'Starting...': 'Starting...',
  'Products Registrations': 'Products Registrations',
  'Start Registration': 'Start Registration',
  'My Registered Products': 'My Registered Products',
  'Register Product': 'Register Product',
  'Start your registration to add products.': 'Start your registration to add products.',
  'No products registered yet.': 'No products registered yet.',
  'Register first product': 'Register first product',
  'Could not load registration data.': 'Could not load registration data.',
  'Error starting registration. Please try again.': 'Error starting registration. Please try again.',
  'Product Detail': 'Product Detail',
  'Product Name': 'Product Name',
  'Category / Group': 'Category / Group',
  'None': 'None',
  'Additional Information': 'Additional Information',
  'Dates': 'Dates',
  'Registraded in': 'Registered on',
  'Classification Answers': 'Classification Answers',
  'Subcategory': 'Subcategory',
  'Registered': 'Registered',
  'Error saving changes.': 'Error saving changes.',
  'Could not load product data.': 'Could not load product data.',
  'Product not found.': 'Product not found.',
  'cert.errCarregarPremiacao': 'Error loading award information.',
  'cert.semPremiacao': 'This product has no registered award.',
  'cert.selecionarFase': 'Select phase',
  'cert.semTemplate': 'No certificate template configured for this award.',
  'cert.gerando': 'Generating...',
  'cert.errGerarCertificado': 'Error generating the certificate. Please try again.',
  'cert.comFundo': 'Print with background',
  'cert.semFundo': 'Print without background',
  'Edit product data': 'Edit product data',
  'No fields configured in the form of this subcategory.': 'No fields configured in the form of this subcategory.',
  'Saving...': 'Saving...',
  'Awarded Product': 'Awarded Product',
  "Producer's Name": "Producer's Name",
  'Product Registration': 'Product Registration',
  'User Profile Data': 'User Profile Data',
  'Authenticated user information': 'Authenticated user information',
  'Edit Profile': 'Edit Profile',
  'Email': 'Email',
  'Global role': 'Global role',
  'Role in contest': 'Role in contest',
  'Current Contest': 'Current Contest',
  'Year': 'Year',
  'Closed': 'Closed',
  'Organization': 'Organization',
  'No active contest': 'No active contest',
  'Judge Panel': 'Judge Panel',
  'My Tables': 'My Tables',
  'Judge Invite': 'Judge Invite',
  'Accept Invite': 'Accept Invite',
  'Decline': 'Decline',
  'Back to my tables': 'Back to my tables',
  'Back to table': 'Back to table',
  'No tables assigned yet': 'No tables assigned yet',
  'Your evaluation tables will appear here when assigned by the organizer.':
    'Your evaluation tables will appear here when assigned by the organizer.',
  'Overall evaluation progress': 'Overall evaluation progress',
  'evaluated': 'evaluated',
  'Evaluation progress': 'Evaluation progress',
  'All products evaluated in this table!': 'All products evaluated in this table!',
  'No products assigned to this table yet.': 'No products assigned to this table yet.',
  'Evaluation Form': 'Evaluation Form',
  'Already evaluated — you can revise': 'Already evaluated — you can revise',
  'Scores': 'Scores',
  'Disqualify product': 'Disqualify product',
  'Disqualify': 'Disqualify',
  'Cancel disqualification': 'Cancel disqualification',
  'Confirm disqualification': 'Confirm disqualification',
  'Reason for disqualification': 'Reason for disqualification',
  'Disqualification reason is required.': 'Disqualification reason is required.',
  'Save evaluation': 'Save evaluation',
  'Evaluation saved!': 'Evaluation saved!',
  'Evaluated': 'Evaluated',
  'Score required': 'Score required',
  'Error saving evaluation. Please try again.': 'Error saving evaluation. Please try again.',
  'Could not load your tables. Please try again later.': 'Could not load your tables. Please try again later.',
  'Could not load table data. Please try again later.': 'Could not load table data. Please try again later.',
  'Could not load evaluation form. Please try again later.': 'Could not load evaluation form. Please try again later.',
  'Contest Categories': 'Contest Categories',
  'Product Categories': 'Product Categories',
  'Add Category': 'Add Category',
  'Categories': 'Categories',
  'Category': 'Category',
  'Category Registration': 'Category Registration',
  'New Category': 'New Category',
  'Edit Category': 'Edit Category',
  'Search CEP': 'Search CEP',
  'Health Service Number': 'Health Service Number',
  'Health Certificate': 'Health Certificate',
  'Duplicate': 'Duplicate',
  'Download Lab Analysis': 'Download Lab Analysis',
  'Download Curation': 'Download Curation Report',
  'Error downloading file': 'Error downloading file',
  'Attach Analysis': 'Attach Analysis',
  'Receive': 'Receive',
  'Receive Product': 'Receive Product',
  'Validate Product': 'Validate Product',
  'Separate Product': 'Separate Product',
  'In Analysis': 'In Analysis',
  'Health Service': 'Health Service',
  'Regional Innovation': 'Regional Innovation',
  'Lab Analyst': 'Lab Analyst',
  'Inspect Product': 'Inspect Product',
  'Send to Analysis': 'Send to Analysis',
  'Send Product': 'Send Product',
  'Transfer Product': 'Transfer Product',
  'Receive Transfered Product': 'Receive Transfered Product',
  'Analysed': 'Analysed',
  'Terms of Service and Privacy Policy': 'Terms of Service and Privacy Policy',
  'By continuing, you agree to the Terms of Service and Privacy Policy.':
    'By continuing, you agree to the Terms of Service and Privacy Policy.',
  'I agree': 'I agree',
  "I've read and agreed to the terms and privacy policy": "I've read and agreed to the terms and privacy policy",
  'Profile': 'Profile',
  'Themes': 'Themes',
  'View Analysis': 'View Analysis',
  'Select All': 'Select All',
  'Question Order': 'Question Order',
  'New Review Sheet': 'New Review Sheet',
  'Edit Review Sheet': 'Edit Review Sheet',
  'Print Sample Submission Procedure': 'Print Sample Submission Procedure',
  'Remarks': 'Remarks',
  'Reset Password': 'Reset Password',
  'History': 'History',
  'Attach Product Analysis': 'Attach Product Analysis',
  'Photographic Record': 'Photographic Record',
  'View Record': 'View Record',
  'Registrations closed': 'Registrations closed',
  'Generate Certificates': 'Generate Certificates',
  'First Position': 'First Position',
  'Second Position': 'Second Position',
  'Third Position': 'Third Position',
  'Position Award': 'Position Award',
  'Print Certificates': 'Print Certificates',
  'Training': 'Training',
  'Training Mode': 'Training Mode',
  'Scan the QR Code on the product label to start the evaluation.':
    'Scan the QR Code on the product label to start the evaluation.',
  'Competition in Progress': 'Competition in Progress',
  'Good morning': 'Good morning',
  'Good afternoon': 'Good afternoon',
  'Good evening': 'Good evening',
  'Welcome to your judge panel': 'Welcome to your judge panel',
  'Your next phase': 'Your next phase',
  'You have {{n}} phases scheduled': 'You have {{n}} phases scheduled',
  '{{fase}} starts at {{date}}.': '{{fase}} starts at {{date}}.',
  "Check the schedule for what's coming up.": "Check the schedule for what's coming up.",
  'Phase': 'Phase',
  'My schedule': 'My schedule',
  'Final score': 'Final score',
  'Position': 'Position',
  'Awarded': 'Awarded',
  'Disqualified': 'Disqualified',
  'evaluations': 'evaluations',
  'Performance by attribute': 'Performance by attribute',
  'No attribute scores to display.': 'No attribute scores to display.',
  'Detailed scores': 'Detailed scores',
  'Attribute': 'Attribute',
  'My score': 'My score',
  'My product': 'My product',
  'Group average': 'Group average',
  'Comment from the table': 'Comment from the table',
  'Team recommendation': 'Team recommendation',
  'Back': 'Back',
  'Waiting to start': 'Waiting to start',
  'In progress': 'In progress',
  'Counting': 'Counting',
  'Finalized': 'Finalized',
  'Phase {{order}}': 'Phase {{order}}',
  'Expected for {{date}}': 'Expected for {{date}}',
  'No date scheduled yet': 'No date scheduled yet',
  'Started on {{date}}': 'Started on {{date}}',
  'Table {{n}}': 'Table {{n}}',
  'Table not assigned yet': 'Table not assigned yet',
  "You're all set for {{concurso}}. We'll let you know as soon as you're assigned to a table.":
    "You're all set for {{concurso}}. We'll let you know as soon as you're assigned to a table.",
  "You're all set. We'll let you know as soon as you're assigned to a table.":
    "You're all set. We'll let you know as soon as you're assigned to a table.",
  'Wait for the organizer to draw the tables.': 'Wait for the organizer to draw the tables.',
  'Once assigned, your tables will appear here automatically.':
    'Once assigned, your tables will appear here automatically.',
  'On the day of the competition, scan the QR Code on each product to evaluate.':
    'On the day of the competition, scan the QR Code on each product to evaluate.',
  'Almost there!': 'Almost there!',
  "The competition phase hasn't started yet — wait for the organizer to begin.":
    "The competition phase hasn't started yet — wait for the organizer to begin.",
  "As soon as the phase starts, you'll be able to scan QR Codes to evaluate.":
    "As soon as the phase starts, you'll be able to scan QR Codes to evaluate.",
  'All caught up!': 'All caught up!',
  "There's no active evaluation phase right now. See you in the next contest!":
    "There's no active evaluation phase right now. See you in the next contest!",
  'Thank you for your participation': 'Thank you for your participation',
  'Your schedule has been completed.': 'Your schedule has been completed.',
  'My Judge Profile': 'My Judge Profile',
  'Your table': 'Your table',
  'Lead Judge': 'Lead Judge',
  "Point the camera at the product's QR Code. The evaluation form opens automatically when detected.":
    "Point the camera at the product's QR Code. The evaluation form opens automatically when detected.",
  'Try again': 'Try again',
  'Enable camera': 'Enable camera',
  'Tap “Enable camera” to allow access. If nothing happens, check the camera permission for this site.':
    'Tap “Enable camera” to allow access. If nothing happens, check the camera permission for this site.',
  'Black image? Switch camera': 'Black image? Switch camera',
  'Camera': 'Camera',
  'The camera is being used by another app. Close it and try again.':
    'The camera is being used by another app. Close it and try again.',
  'No camera was found on this device.': 'No camera was found on this device.',
  'Could not start the camera. Check the permission and that no other app is using it.':
    'Could not start the camera. Check the permission and that no other app is using it.',
  'The camera only works over a secure connection (https).': 'The camera only works over a secure connection (https).',
  'Camera access is blocked. Tap the lock/menu icon next to the address bar, open Permissions and allow the Camera, then reload the page.':
    'Camera access is blocked. Tap the lock/menu icon next to the address bar, open Permissions and allow the Camera, then reload the page.',
  'Product characteristics': 'Product characteristics',
  'Comments': 'Comments',
  'Comment is required for the lead judge.': 'Comment is required for the lead judge.',
  'General observations about the product...': 'General observations about the product...',
  "Lead judge feedback — register the table's consolidated impression about this product.":
    "Lead judge feedback — register the table's consolidated impression about this product.",
  'characters': 'characters',
  'All evaluations done!': 'All evaluations done!',
  'You finished evaluating every product on your tables.': 'You finished evaluating every product on your tables.',
  'Thank you for your work!': 'Thank you for your work!',
  'You are evaluating as Lead Judge': 'You are evaluating as Lead Judge',
  'If you have any questions, please contact the organizer.':
    'If you have any questions, please contact the organizer.',
  'Completed': 'Completed',
  'Progress': 'Progress',
  'registration': 'registration',
  'Scan Product': 'Scan Product',
  'Table Code': 'Table Code',
  'Curation': 'Curation',
  'Consultant Analysis': 'Consultant Analysis',
  'Download Award Seal': 'Download Award Seal',
  // Compartilhar premiação nas redes
  'Share': 'Share',
  'Share your award': 'Share your award',
  'Generating image...': 'Generating image...',
  'Award image': 'Award image',
  'Suggested text': 'Suggested text',
  'Copy text': 'Copy text',
  'Download image': 'Download image',
  'Share on LinkedIn': 'Share on LinkedIn',
  'Text copied': 'Text copied',
  'Could not copy the text': 'Could not copy the text',
  'Could not open sharing. Download the image instead.': 'Could not open sharing. Download the image instead.',
  'The award seal is not in a supported format (PNG, JPG, SVG or PDF), so it cannot be shared. Please contact the organizers.':
    'The award seal is not in a supported format (PNG, JPG, SVG or PDF), so it cannot be shared. Please contact the organizers.',
  'Could not generate the image. Please try again.': 'Could not generate the image. Please try again.',
  'The organizer logo could not be loaded, so the image was generated without it.':
    'The organizer logo could not be loaded, so the image was generated without it.',
  'For Instagram, post the downloaded image from your phone and paste the copied text in the caption.':
    'For Instagram, post the downloaded image from your phone and paste the copied text in the caption.',
  'My product {{produto}} won {{selo}} at {{concurso}} {{ano}}! {{hashtag}}':
    'My product {{produto}} won {{selo}} at {{concurso}} {{ano}}! {{hashtag}}',
  'Your Judge Certificate': 'Your Judge Certificate',
  'Your certificate is ready': 'Your certificate is ready',
  'Download your certificate to print or save.': 'Download your certificate to print or save.',
  'View Certificate': 'View Certificate',
  'Downloading...': 'Downloading...',
  'Could not download the certificate. Please try again later.':
    'Could not download the certificate. Please try again later.',
  'Reviewed': 'Reviewed',
  'Download Consultant Analysis': 'Download Consultant Analysis',
  'Active Producers': 'Active Producers',
  'Active Foreign Producers': 'Active Foreign Producers',
  'Approved Judges': 'Approved Judges',
  'Total registered judges': 'Total registered judges',
  'Total registered users': 'Total registered users',
  'Total Registered Products': 'Total Registered Products',
  'Received Products': 'Received Products',
  'Products in Analysis': 'Products in Analysis',
  'Products pending approval': 'Products pending approval',
  'Approved Products': 'Approved Products',
  'Failed Products': 'Failed Products',
  'Products in Transit': 'Products in Transit',
  'Transfered Products': 'Transfered Products',
  'Separated Products': 'Separated Products',
  'Total active producers': 'Total active producers',
  'Product Characteristics': 'Product Characteristics',
  'Add Characteristic': 'Add Characteristic',
  'Type': 'Type',
  'Ordering': 'Ordering',
  'Characteristics': 'Characteristics',
  'Edit Characteristic': 'Edit Characteristic',
  'New Characteristic': 'New Characteristic',
  'Text': 'Text',
  'Minimum Value': 'Minimum Value',
  'Maximum Value': 'Maximum Value',
  'Value': 'Value',
  'Active Category': 'Active Category',
  'Characteristic': 'Characteristic',
  'Next': 'Next',
  'Leite': 'Milk',
  'Tipo de Leite': 'Milk Type',
  'Leite Cru': 'Raw Milk',
  'Leite Pasteurizado': 'Pasteurized Milk',
  'Your cateogry is': 'Your cateogry is',
  'Reset': 'Reset',
  'Values': 'Values',
  'Change': 'Change',
  'Casca': 'Rind',
  'Tratamento da Massa': 'Dough Treatment',
  'Maturação': 'Maturation',
  'Leite de Vaca': 'Cow Milk',
  'Leite de Cabra': 'Goat Milk',
  'Leite de Ovelha': 'Sheep Milk',
  'Leite de Búfala': 'Buffalo Milk',
  'Maturado': 'Aged',
  'Massa filada': 'Spliced Pasta',
  'Massa não filada': 'Unspliced Pasta',
  'Não se aplica': 'Not apply',
  'by': 'por',
  'Criado': 'Created',
  'Pago': 'Paid',
  'Aprovado': 'Approved',
  'Avaliado': 'Reviewed',
  'Reprocess': 'Reprocess',
  'Confirms category duplication': 'Confirms category duplication',
  'Available': 'Available',
  'Has counter evidence': 'Has counter evidence',
  'Add Selected Judges': 'Add Selected Judges',
  'Phase updated successfully': 'Phase updated successfully',
  'Phase registred successfully': 'Phase registred successfully',
  'Repeat Judges': 'Repeat Judges',
  'New Contest Phase': 'New Contest Phase',
  'Edit Contest Phase': 'Edit Contest Phase',
  'Add New Phase': 'Add New Phase',
  'Started': 'Started',
  'In Progress': 'In Progress',
  'Counting Votes': 'Counting Votes',
  'Number of Products': '# of Products',
  'Coupons': 'Coupons',
  'Coupon': 'Coupon',
  'Discount Type': 'Discount Type',
  'Quantity': 'Quantity',
  'Quantity Left': 'Quantity Left',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Add Coupon': 'Add Coupon',
  'New Coupon': 'New Coupon',
  'Porcentage': 'Porcentage',
  'Money': 'Money',
  'Edit Coupon': 'Edit Coupon',
  'Milk coagulation day': 'Milk coagulation day',
  'Discount': 'Discount',
  'Total with Discounts': 'Total with Discounts',
  'Cupom inválido': 'Invalid coupon',
  'Apply Coupon': 'Apply Coupon',
  'Copied to clipboard': 'Copied to clipboard',
  'Declassify Product': 'Declassify Product',
  'Justification': 'Justification',
  'Product declassified successfully': 'Product declassified successfully',
  'Paid with coupon': 'Paid with coupon',
  'Confirm Payment': 'Confirm Payment',
  'All': 'All',
  'Expired': 'Expired',
  'Awaiting Payment': 'Awaiting Payment',
  'Start Expiring Date': 'Start Expiring Date',
  'End Expiring Date': 'End Expiring Date',
  'Finished': 'Finished',
  'Attach Photographic Record': 'Attach Photographic Record',
  'Award Phase': 'Award Phase',
  'Last Contest Phase': 'Last Contest Phase',
  'Not Started': 'Not Started',
  'Qualified': 'Qualified',
  'Justification of Declassification': 'Justification of Declassification',
  'Shuffle Judges': 'Shuffle Judges',
  'Technical Advisor': 'Technical Advisor',
  'Date of Birth': 'Date of Birth',
  'Address': 'Address',
  'Number': 'Number',
  'Complement': 'Complement',
  'Neighborhood': 'Neighborhood',
  'Print by Podium': 'Print by Podium',
  'Print All Certificates': 'Print All Certificates',
  'Reset Status': 'Reset Status',
  'Restrictions': 'Restrictions',
  'Available Products': 'Available Products',
  'table': 'table',
  'Add Table': 'Add Table',
  'Approval': 'Approval',
  'Generate PDF': 'Generate PDF',
  'Access your account': 'Access your account',
  'Update': 'Update',
  'Account': 'Account',
  'Select Client': 'Select Client',
  'wizard.back': 'Back',
  'wizard.continue': 'Continue',
  'wizard.next': 'Next',
  'wizard.steps.0': 'Account Details',
  'wizard.steps.1': 'Choose Contest',
  'wizard.steps.2': 'Registration',
  'wizard.steps.3': 'Conclusion',
  'wizard.step1.title': 'Account Settings',
  'wizard.step1.subtitle': 'Select your preferred language and accept the terms to continue.',
  'wizard.step1.idiomaLabel': 'Preferred Language',
  'wizard.step1.lgpd.title': 'Terms of Service and Privacy Policy',
  'wizard.step1.lgpd.body':
    'By using our system, you agree to the Terms of Service and Privacy Policy. Your personal data will be processed exclusively for the purposes described in our policy, including sending communications and conducting surveys on behalf of the contest organizer.',
  'wizard.step1.lgpd.link': 'View full policy ↗',
  'wizard.step1.lgpd.agree': 'I have read and agree to the <b>Terms of Service</b> and <b>Privacy Policy</b>',
  'wizard.step2.title': 'Choose your contest',
  'wizard.step2.subtitle': 'Select the contest you want to enter.',
  'wizard.step2.noConcursos':
    'No contests with open registrations at the moment. Please contact the organizer for more information.',
  'wizard.step2.inscricoes': 'Registrations',
  'wizard.step2.evento': 'Event',
  'wizard.step2.gratuito': 'Free',
  'wizard.step2.valor': 'Entry fee',
  'wizard.step3.title': 'Complete your registration',
  'wizard.step3.subtitle': 'Fill in the details below to complete your registration as a producer.',
  'wizard.step4.title': 'Registration complete!',
  'wizard.step4.subtitle':
    'Your registration in <b>{{nomeConcurso}}</b> was successfully completed. You can now register your products or access the dashboard.',
  'wizard.step4.inscreverproduto': 'Register first product',
  'wizard.step4.irpainel': 'Go to dashboard',
  'wizard.jurado.step2.label': 'Registration',
  'wizard.jurado.step2.title': 'Complete your registration as a judge',
  'wizard.jurado.step2.subtitle': 'Fill in the details below to complete your registration as a judge.',
  'wizard.jurado.step3.title': 'Registration complete!',
  'wizard.jurado.step3.subtitle': 'Your registration as a judge has been completed. You can now access your panel.',
  'wizard.jurado.step3.irpainel': 'Go to judge panel',
  'wizard.jurado.erroCarregarFormulario': 'Error loading registration form. Please try again.',
  'resultados.titulo': 'Contest Results',
  'resultados.todos': 'All Groups',
  'resultados.semConcursoAtivo': 'No active contest found.',
  'resultados.semResultados': 'No results published yet.',
  'resultados.erroCarregar': 'Error loading results. Please try again.',
  'resultados.produto.titulo': 'My Product Result',
  'resultados.produto.voltar': 'Back',
  'resultados.produto.naoEncontrado': 'Result not found for this product.',
  'resultados.produto.notasPorCriterio': 'Notes by Criterion',
  'Contest Results': 'Contest Results',
  'Language preference not saved. Please try again.': 'Language preference not saved. Please try again.',
  // Curador
  'Curator': 'Curator',
  // Convite de Jurado
  'convite.titulo': 'Judge Invite',
  'convite.cabecalho': "You've been invited to be a Judge",
  'convite.descricao': 'By accepting, you will be redirected to create your account and access the contest as a judge.',
  'convite.aceitar': 'Accept Invite',
  'convite.recusar': 'Decline',
  'convite.confirmarRecusaTitulo': 'Decline Invite',
  'convite.confirmarRecusaTexto': 'Are you sure you want to decline this judge invite? This action cannot be undone.',
  'convite.confirmarRecusa': 'Yes, decline',
  'convite.voltar': 'Go back',
  'convite.recusadoTitulo': 'Invite declined.',
  'convite.recusadoSubtitulo': 'You have declined the judge invite. You can close this page.',
  'convite.erroRecusar': 'Error declining invite. Please try again.',
  // Inscrição de Produto
  'inscricao.nova.titulo': 'Product Registration',
  'inscricao.nova.tituloCurto': 'New Registration',
  'inscricao.nova.breadcrumb': 'Registrations',
  'inscricao.nova.passo.classificacao': 'Classification',
  'inscricao.nova.passo.dados': 'Product Details',
  'inscricao.nova.secao.categorias': 'Product Categories',
  'inscricao.nova.secao.dados': 'Product Details',
  'inscricao.nova.campoObrigatorio': 'Required field',
  'inscricao.nova.classificada.titulo': 'Product registered!',
  'inscricao.nova.refazer': 'Redo',
  'inscricao.nova.wizard.erroCarga': 'Could not start classification.',
  'inscricao.nova.wizard.tentarNovamente': 'Try again',
  'inscricao.nova.wizard.semMatch.titulo': 'No matching category found',
  'inscricao.nova.wizard.refazerClassificacao': 'Redo classification',
  'inscricao.nova.wizard.multiplosResultados':
    'We found more than one option. Choose the one that best describes your product:',
  'inscricao.nova.wizard.aguarde': 'Please wait...',
  'inscricao.nova.wizard.avancar': 'Next',
  'inscricao.nova.wizard.etapa': 'Step',
  'inscricao.nova.wizard.certificado': 'Certified',
  'inscricao.nova.direto.semGrupos': 'No groups available for direct selection in this contest.',
  'inscricao.nova.direto.label': 'Select product category',
  'inscricao.nova.direto.placeholder': 'Search by category, subcategory or group...',
  'inscricao.nova.direto.semOpcoes': 'No groups found',
  'inscricao.nova.tabs.wizard': 'Wizard (recommended)',
  'inscricao.nova.tabs.direto': 'Direct selection',
  'inscricao.nova.classificadoAlertPre': 'Product classified under',
  'inscricao.nova.classificadoAlertPos': 'Click',
  'inscricao.nova.classificadoAlertPos3': 'to continue.',
  'inscricao.nova.categoriaSelecionada': 'Selected Category',
  'inscricao.nova.form.identificacao': 'Identification',
  'inscricao.nova.form.nome': 'Product name *',
  'inscricao.nova.form.nomeObrigatorio': 'Product name is required',
  'inscricao.nova.form.nomePlaceholder': 'E.g.: name shown on the certificate',
  'inscricao.nova.form.caracteristicas': 'Product characteristics',
  'inscricao.nova.form.camposObrigatorios': 'Fill in all required fields marked with *.',
  'inscricao.nova.acoes.cancelar': 'Cancel',
  'inscricao.nova.acoes.voltar': 'Back',
  'inscricao.nova.acoes.proximaEtapa': 'Next step',
  'inscricao.nova.acoes.inscrevendo': 'Registering...',
  'inscricao.nova.acoes.inscrever': 'Register Product',
  'inscricao.nova.erroCarga': 'Could not load contest information. Please try again.',
  'inscricao.nova.erroSubmit': 'Error registering product. Check the data and try again.',
  'inscricao.nova.feedback.sucesso': 'Product successfully registered!',
  'inscricao.nova.feedback.verProdutos': 'View my products',
  // Campos do formulário de produtor (por código)
  'campo.nome': 'Name',
  'campo.nome_completo': 'Full Name',
  'campo.nome_fazenda': "Farm's Name",
  'campo.representante_legal': 'Legal Representative',
  'campo.cpf': 'CPF',
  'campo.cnpj': 'CNPJ',
  'campo.rg': 'RG',
  'campo.passaporte': 'Passport',
  'campo.tipo_documento': 'ID Document Type',
  'campo.email': 'E-mail',
  'campo.celular': 'Cellphone',
  'campo.telefone': 'Phone Number',
  'campo.pais': 'Country',
  'campo.cidade': 'City',
  'campo.estado': 'State',
  'campo.cep': 'ZIP Code',
  'campo.search_cep': 'Search ZIP Code',
  'campo.endereco_logradouro': 'Address',
  'campo.endereco_numero': 'Number',
  'campo.endereco_complemento': 'Complement',
  'campo.endereco_bairro': 'Neighborhood',
  'campo.endereco_cidade': 'City',
  'campo.endereco_uf': 'State',
  'campo.website': 'Website',
  'campo.data_nascimento': 'Date of Birth',
  'campo.siapp': 'SIAPP Number',
  'campo.servico_sanitario': 'Health Certificate',
  'campo.numero_servico_sanitario': 'Health Service Number',
  'campo.aceite_lgpd': 'Data Protection Consent',
  'campo.aceite_termos': 'Terms of Service',
  'campo.aceite_imagem': 'Image Use Authorization',
  'My Producer Profile': 'My Producer Profile',
  'Performance Report': 'Performance Report',
  'Download PDF': 'Download PDF',
  'Generating...': 'Generating...',
  'Judge opinion': 'Opinion',
  'Justify your scores — required in this phase.': 'Justify your scores — required in this phase.',
  'Opinion is required in this phase.': 'An opinion is required in this phase.',
  'Open file {{nome}}': 'Open {{nome}}',
  'Panel opinions': 'Panel opinions',
  // Avaliação remota: a mesa aparece pro jurado como "Banca"
  'Panel {{n}}': 'Panel {{n}}',
  'Voting until {{date}}': 'Voting until {{date}}',
  'Read more': 'Read more',
  'Read less': 'Read less',
  'Voting closed on {{date}}': 'Voting closed on {{date}}',
  'Panel not assigned yet': 'Panel not assigned yet',
  'Panel': 'Panel',
  'Your panel': 'Your panel',
  'Back to my panels': 'Back to my panels',
  'Back to panel': 'Back to panel',
  'All products evaluated in this panel!': 'All products evaluated in this panel!',
  'No products assigned to this panel yet.': 'No products assigned to this panel yet.',
  'As soon as the phase starts, the products to evaluate will appear here.':
    'As soon as the phase starts, the products to evaluate will appear here.',
  'You finished evaluating every product on your panels.': 'You finished evaluating every product on your panels.',
  'Opinion {{n}}': 'Opinion {{n}}',
  'Click <b>New Registration</b> to register your first product.':
    'Click <b>New Registration</b> to register your first product.',
  'this product': 'this product',
  'This product has not been evaluated in any finalized phase yet.':
    'This product has not been evaluated in any finalized phase yet.',
  'Reject': 'Reject',
  'Rejected': 'Rejected',
  'Approve or reject this product.': 'Approve or reject this product.',
  'Choose Approve or Reject.': 'Choose Approve or Reject.',
  'Favorite': 'Favorite',
  'Mark as favorite': 'Mark as favorite',
  'Remove from favorites': 'Remove from favorites',
  'Choose up to {{k}} favorites among the products you evaluate. You can change your choice until the deadline.':
    'Choose up to {{k}} favorites among the products you evaluate. You can change your choice until the deadline.',
  '{{n}} of {{k}} favorites chosen': '{{n}} of {{k}} favorites chosen',
  'You have already chosen {{k}} favorites. Remove one to choose another.':
    'You have already chosen {{k}} favorites. Remove one to choose another.',
  'Save vote': 'Save vote',
  'Vote saved!': 'Vote saved!',
  'Justify your vote — required in this phase.': 'Justify your vote — required in this phase.',
  'Favorites chosen': 'Favorites chosen',
  'Approval rate': 'Approval rate',
  'Votes': 'Votes',
  'votes': 'votes',
  'Popular vote': 'Popular vote',
  'Could not load the vote. Try again in a few minutes.': 'Could not load the vote. Try again in a few minutes.',
  'Voting starts on {{date}}': 'Voting starts on {{date}}',
  'Vote until {{date}}': 'Vote until {{date}}',
  'There is no popular vote in this contest right now.': 'There is no popular vote in this contest right now.',
  'Voting is closed. Thank you for taking part!': 'Voting is closed. Thank you for taking part!',
  'vote': 'vote',
  'You voted': 'You voted',
  'Vote': 'Vote',
  'Something went wrong. Try again.': 'Something went wrong. Try again.',
  'Vote confirmed!': 'Vote confirmed!',
  'Vote for {{name}}': 'Vote for {{name}}',
  'I have read and accept the rules of the popular vote': 'I have read and accept the rules of the popular vote',
  'Hide rules': 'Hide rules',
  'Read the rules': 'Read the rules',
  'We sent a code to {{email}}. It is valid for 15 minutes — check your spam folder too.':
    'We sent a code to {{email}}. It is valid for 15 minutes — check your spam folder too.',
  'Resend code in {{s}}s': 'Resend code in {{s}}s',
  'Resend code': 'Resend code',
  'Change e-mail': 'Change e-mail',
  'Your vote for {{name}} was counted. Thank you!': 'Your vote for {{name}} was counted. Thank you!',
  'Send code': 'Send code',
  'Confirm vote': 'Confirm vote',
  'Popular vote is open — vote for your favorite': 'Popular vote is open — vote for your favorite',
  'Poor': 'Poor',
  'Excellent': 'Excellent',
  'Final score (jury + public)': 'Final score (jury + public)',
  'Public {{nota}} (popular vote only)': 'Public {{nota}} (popular vote only)',
  'Jury {{juri}} × {{pj}}% + Public {{publico}} × {{pp}}%': 'Jury {{juri}} × {{pj}}% + Public {{publico}} × {{pp}}%',
  '{{n}} public vote': '{{n}} public vote',
  '{{n}} public votes': '{{n}} public votes',
  'Page not found': 'Page not found',
  "Oops! This page didn't make the podium.": "Oops! This page didn't make the podium.",
  'The address may have changed or the link is incomplete. How about going back and trying again?':
    'The address may have changed or the link is incomplete. How about going back and trying again?',
  'Go to the home page': 'Go to the home page',
  'Previous page': 'Previous page',
  'Error 404': 'Error 404',
  'Access closed': 'Access closed',
  'This platform is no longer available. For questions, please contact the organizer.': 'This platform is no longer available. For questions, please contact the organizer.',
  'In this vote you vote through the QR code available at each place.':
    'In this vote you vote through the QR code available at each place.',
  'Your evaluation': 'Your evaluation',
  'Your vote': 'Your vote',
  'This candidate is not in a popular vote right now.': 'This candidate is not in a popular vote right now.',
  'You have already voted for this candidate on this device.':
    'You have already voted for this candidate on this device.',
  'Choose up to {{k}} favorites in each category.': 'Choose up to {{k}} favorites in each category.',
  'Choose up to {{k}} favorites.': 'Choose up to {{k}} favorites.',
  'Choose your favorite in each category.': 'Choose your favorite in each category.',
  'Choose your favorite.': 'Choose your favorite.',
  'Rate each candidate you try — one evaluation per person for each candidate.':
    'Rate each candidate you evaluate — one evaluation per person for each candidate.',
  'Approve or reject each candidate — one evaluation per person for each candidate.':
    'Approve or reject each candidate — one evaluation per person for each candidate.',
  'The limit renews every day.': 'The limit renews every day.',
  'Each vote is confirmed by a code sent to your e-mail.': 'Each vote is confirmed by a code sent to your e-mail.',
  'evaluation': 'evaluation',
  'approval': 'approval',
  'Evaluate': 'Evaluate',
  'Evaluate {{name}}': 'Evaluate {{name}}',
  'We will send a 6-digit code to your e-mail to confirm the vote. Your data is used only to validate the vote.':
    'We will send a 6-digit code to your e-mail to confirm the vote. Your data is used only to validate the vote.',
  'CPF (optional)': 'CPF (optional)',
  'Continue': 'Continue',
  'See all candidates': 'See all candidates',
  // Visual novo (shell/auth no padrão do konq-backoffice)
  'Menu': 'Menu',
  'Contests': 'Contests',
  'Judge invitation': 'Judge invitation',
  'Use the email {{email}} to create your account.': 'Use the email {{email}} to create your account.',
  'Pending approval': 'Pending approval',
  'Your judge invitation is under review. You will be notified as soon as your participation is confirmed.':
    'Your judge invitation is under review. You will be notified as soon as your participation is confirmed.',
  'products registered': 'products registered',
  'auth.tagline.title': 'Excellence that deserves recognition',
  'auth.tagline.subtitle':
    'Register your products, follow the evaluations and celebrate your achievements — all in one place.',
  'Download lab analysis report': 'Download lab analysis report',
  'Until {{date}}': 'Until {{date}}',
  'termos.organizadorPadrao': 'the contest organizer',
  'termos.lgpd.tratamento':
    'In accordance with Brazilian Law No. 13,709/2018 (General Personal Data Protection Law — LGPD) and other applicable data protection rules, I freely, knowingly and unequivocally authorize {{organizador}} to process my personal data for the purposes of this contest: registering and evaluating products, communicating about the contest, handling requests and conducting surveys of interest to the organizer, as well as using my image and voice in photos, documents and other communication materials for promotional and institutional campaigns.',
  'termos.lgpd.compartilhamento':
    "By registering, I authorize the laboratory analysis results and my data to be shared <b>ONLY</b> with the representatives of {{organizador}} on the contest's technical committee, and I declare that I agree with and comply with all terms of the contest rules.",
  'termos.imagem.titulo': 'Image use authorization',
  'termos.imagem.aceitar': 'I agree',
  'termos.imagem.texto':
    'I, {{nome}}, holder of ID (RG) No. {{rg}} and CPF No. {{cpf}}, authorize the use of my image and voice in marketing, publicity and social media actions and any other advertising pieces that may be needed, including in print or any other means of dissemination, for the exclusive use of {{organizador}} and for an indefinite period.',
  'landing.inscricoes': 'Registrations',
  'landing.entrar': 'Sign in',
  'landing.cadastrar': 'Sign up',
  'landing.hero.titulo': 'Register your product.<br/>Earn your place.',
  'landing.inscricoesAbertas': 'Open registrations',
  'landing.encerradas.titulo': 'Registrations are closed at the moment',
  'landing.encerradas.texto': 'Contact the organizer to hear about upcoming contests.',
  'landing.privacidade': 'Privacy Policy',
  'landing.card.periodoInscricoes': 'Registration period',
  'landing.card.dataEvento': 'Event date',
  'landing.card.taxa': 'Registration fee',
  'landing.card.gratuito': 'Free',
  'landing.card.participar': 'Take part',
  'landing.hero.subtitulo': 'Join the available contests, register your products and follow the results in real time.',
  'Ouro': 'Gold',
  'Prata': 'Silver',
  'Bronze': 'Bronze',
  'resultados.produto.pontos': '{{nota}} pts',
  'resultados.produto.semCriterios': 'No criteria available.',
  'resultados.produto.criterio': 'Criterion',
  'resultados.produto.notaMedia': 'Average score',
  'resultados.produto.maximo': 'Maximum',
  'resultados.produto.desempenho': 'Performance',
  'convite.naoEncontrado': 'Invitation not found.',
  'convite.expirado': 'This invitation has expired.',
  'convite.jaAceito': 'This invitation has already been accepted.',
  'convite.revogado': 'This invitation has been revoked.',
  'convite.erroBuscar': 'Could not load the invitation. Please try again.',
  'convite.carregando': 'Loading invitation...',
  'convite.invalido': 'Invalid invitation',
  'convite.cabecalhoNomeado': '{{nome}}, you have been invited to be a Judge',
  'arquivo.erroUpload': 'File upload failed.',
  'arquivo.erroAbrir': 'Could not open the file.',
  'arquivo.enviando': 'Uploading...',
  'arquivo.substituir': 'Replace file',
  'arquivo.selecionar': 'Select file',
  'arquivo.ate': 'up to {{mb}}MB',
  'arquivo.multiplos': 'multiple files',
  'arquivo.um': '1 file',
  'arquivo.abrir': 'Open',
  'arquivo.remover': 'Remove',
  'data.aPartirDe': 'Date must be on or after {{date}}',
  'data.ateDia': 'Date must be on or before {{date}}',
  'data.invalida': 'Invalid date',
  'validacao.cnpjInvalido': 'Invalid CNPJ',
  'validacao.cpfInvalido': 'Invalid CPF',
  'validacao.cpfErroVerificar': 'Error checking CPF.',
  'validacao.erroSalvarCadastro': 'Error saving registration.',
  'validacao.camposFaltando': 'Required fields not filled in: {{campos}}',
  // Pente fino de i18n (textos que estavam fixos no código)
  'erroFatal.titulo': 'Something went wrong',
  'erroFatal.texto':
    'We ran into an unexpected problem. The error was reported automatically and our team is looking into it.',
  'erroFatal.detalhes': 'Technical details',
  'erroFatal.tentarNovamente': 'Try again',
  'erroFatal.recarregar': 'Reload the page',
  'semAcessoTenant.titulo': 'No access to this contest',
  'semAcessoTenant.texto':
    "Your account doesn't have access to the contest <b>{{slug}}</b>. Check that you signed in with the right e-mail, or ask the organizer for access.",
  'validacao.cnpjJaCadastradoProdutor': 'CNPJ already registered by another producer.',
  'validacao.cpfJaCadastradoProdutor': 'CPF already registered by another producer.',
  'validacao.cadastroSalvo': 'Registration saved successfully!',
  'validacao.linkInvalido.titulo': 'Invalid registration link',
  'validacao.linkInvalido.texto': 'Open the registration link provided by the contest organizer to continue.',
  'checkout.titulo': 'Registration payment',
  'checkout.passos.resumo': 'Summary',
  'checkout.passos.cupom': 'Coupon',
  'checkout.passos.pagamento': 'Payment',
  'checkout.passos.confirmacao': 'Confirmation',
  'checkout.formas.pix': 'Pix',
  'checkout.formas.boleto': 'Bank slip (boleto)',
  'checkout.erroCarregar': 'Error loading registration data.',
  'checkout.cupomInvalido': 'Invalid or non-applicable coupon.',
  'checkout.erroGerarFatura': 'Error generating the invoice. Please try again.',
  'checkout.desabilitado': 'Payment is not enabled for this contest.',
  'checkout.resumoPedido': 'Order summary',
  'checkout.taxaPorProduto': 'Fee per product',
  'checkout.produtosInscritos': 'Registered products',
  'checkout.total': 'Total',
  'checkout.cupomDesconto': 'Discount coupon',
  'checkout.codigoCupom': 'Coupon code',
  'checkout.aplicar': 'Apply',
  'checkout.descontoAplicado': '{{desconto}} discount applied! New total: {{total}}',
  'checkout.continuarComDesconto': 'Continue with discount',
  'checkout.pular': 'Skip',
  'checkout.formaPagamento': 'Payment method',
  'checkout.selecione': 'Select',
  'checkout.subtotal': 'Subtotal',
  'checkout.descontoCupom': 'Discount (coupon)',
  'checkout.totalAPagar': 'Total due',
  'checkout.confirmarPagamento': 'Confirm payment',
  'checkout.pagamentoConfirmado': 'Payment confirmed!',
  'checkout.pedido': 'Order: {{numero}}',
  'checkout.irParaInscricao': 'Go to my registration',
  'checkout.vencido': 'Payment expired. Generate a new invoice.',
  'checkout.tentarNovamente': 'Try again',
  'checkout.aguardandoPagamento': 'Awaiting payment',
  'checkout.pendente': 'Pending',
  'checkout.pixCopiaECola': 'Pix copy and paste',
  'checkout.copiarPix': 'Copy Pix code',
  'checkout.codigoBarras': 'Barcode',
  'checkout.copiarCodigoBarras': 'Copy barcode',
  'checkout.abrirBoleto': 'Open boleto',
  'Winner': 'Winner',
  'desempenho.fasesAvaliadas_one': '{{count}} phase evaluated',
  'desempenho.fasesAvaliadas_other': '{{count}} phases evaluated',
  'desempenho.erroRelatorio': 'Could not load the performance report.',
  'desempenho.erroCarregar': 'Could not load the performance.',
  'ficha.titulo': 'Product shipping form',
  'ficha.codigoProduto': 'Product code',
  'ficha.caracteristicas': 'Product characteristics',
  'ficha.instrucoes.titulo': 'Instructions',
  'ficha.instrucoes.1': '1. Print this form and attach it visibly to the product packaging.',
  'ficha.instrucoes.2': '2. The code <b>{{codigo}}</b> is unique and identifies this product throughout the contest.',
  'ficha.instrucoes.3': '3. The QR code lets the operator quickly find and update this product at any stage.',
  'ficha.instrucoes.4': '4. Keep the form intact until the end of the evaluation.',
  'ficha.rodape': 'Konq · Contest Platform',
  'ficha.umProduto': 'a product by',
  'ficha.preparando': 'Preparing form...',
  'Subcontest': 'Subcontest',
  'Seal URL not found': 'Seal URL not found',
  'Error loading seal for printing': 'Error loading seal',
  'Product description': 'Product description',
  'Loading...': 'Loading...',
  'No transitions registered.': 'No transitions registered.',
  'Download Seal': 'Download seal',
  'Product name': 'Product name',
  'Name is required': 'Name is required',
  'Description is required': 'Description is required',
  'cert.baixar': 'Download certificate',
  'inscricao.nova.direto.variacao': 'Variation',
  'inscricao.nova.form.descricao': 'Product description',
  'inscricao.nova.form.descricaoObrigatoria': 'Description is required',
  'inscricao.nova.form.descricaoPlaceholder': 'Batch, additional information...',
  'treinamento.produto': 'Training Product {{n}}',
  'treinamento.categoria': 'Training Category',
  'treinamento.atributos.aparencia.nome': 'Appearance',
  'treinamento.atributos.aparencia.descricao': "Evaluate the product's visual appearance.",
  'treinamento.atributos.aroma.nome': 'Aroma',
  'treinamento.atributos.aroma.descricao': 'Evaluate the characteristic aroma.',
  'treinamento.atributos.sabor.nome': 'Flavor',
  'treinamento.atributos.sabor.descricao': 'Evaluate the predominant flavor.',
  'treinamento.atributos.textura.nome': 'Texture',
  'treinamento.atributos.textura.descricao': 'Evaluate texture and consistency.',
  'treinamento.atributos.apresentacao.nome': 'Presentation',
  'treinamento.atributos.apresentacao.descricao': 'Evaluate the overall presentation.',
  'resultados.semResultadosCategoria': 'No results published for this category.',
  'resultados.produto.lugar': '#{{posicao}}',
  'resultados.produto.deTotal': 'of {{total}}',
  'perfil.estado.conviteJuradoPendente': 'Pending judge invitation',
  'perfil.estado.produtorSemInscricao': 'Producer (not registered)',
  'erro.operacao': 'Error performing the operation',
  'Training available': 'Training available',
  'Start training': 'Start training',
  'Practice evaluation with a simulated list of products. Nothing is sent to the server.':
    "Practice evaluating with test products. Your scores don't count in the real contest.",
  'Training Table': 'Training Table',
  'Scan the QR code shown by the instructor or tap a product to open the form.':
    'Scan the QR code shown by the instructor or tap a product to open the form.',
  'Simulated evaluation. Nothing is sent to the server.':
    "This is a training evaluation — it doesn't count in the real contest.",
  'Reset training? Local saved evaluations will be removed.':
    'Reset training? All your training scores will be erased.',
  'Training product not found.': 'Training product not found.',
  'Back to training': 'Back to training',
  'Training evaluation saved on this device.': 'Training evaluation saved!',
  'Save training evaluation': 'Save evaluation',
  'Out of range': 'Out of range',
  'Disqualify this product': 'Disqualify this product',
  'Disqualification reason': 'Disqualification reason',
  'Required': 'Required',
  'Total': 'Total',
  'Access as': 'Access as',
  'Choose a real user to impersonate. All actions persist as that user — be careful.':
    'Choose a real user to access as. All actions are recorded in their name — use with care.',
  'No active contest for this tenant.': 'No active contest for this tenant.',
  'Could not load the active contest.': 'Could not load the active contest.',
  'Search by name or email…': 'Search by name or e-mail…',
  'No results.': 'No results.',
  'Could not load the list. Try again.': 'Could not load the list. Try again.',
  'Impersonate': 'Access as',
  'Showing the first 50 judges. Use search to filter.': 'Showing the first 50 judges. Use search to filter.',
  'Showing the first 50 producers. Use search to filter.': 'Showing the first 50 producers. Use search to filter.',
  'Impersonating': 'Accessing as',
  'as Judge': '(Judge)',
  'as Producer': '(Producer)',
  'Exit impersonation': 'Exit',
  'Curador': 'Curator',
  'Viewing as {{nome}}: this profile is read-only.': 'Viewing as {{nome}}: this profile is read-only.',
  'cadastro.erroCarregarFormulario': 'Error loading the registration form. Please try again.',
  'validacao.cnpjErroVerificar': 'Error checking CNPJ.',
  'My evaluations': 'My evaluations',
  'validacao.campoObrigatorio': 'Required field',
};

export default en;
